// import { HttpClient } from '@angular/common/http';
// import { Injectable } from '@angular/core';
// import { environment } from '../../../environments/environment';
// import { Observable } from 'rxjs';
// import { Signin, SignInResponse } from '../interfaces/signin.interface';

// @Injectable({
//   providedIn: 'root'
// })
// export class AuthService {

//   private baseUrl = environment.baseUrl;

//   constructor(private http:HttpClient) { }


//   setToken(token: string): void {
//     localStorage.setItem('authToken', token);
//   }

//   getToken(): string | null {
//     return localStorage.getItem('authToken');
//   }

//   removeToken(): void {
//     localStorage.removeItem('authToken');
//   }

//   isAuthenticated(): boolean {
//     // const token = localStorage.getItem('authToken');
//     return false;
//   }

//   nriSignUp(data: any): Observable<any> {
//     return this.http.post(`${this.baseUrl}/auth/local/register`, data);
//   }

//   serviceProviderSignUp(data:any) {
//     return this.http.post(`${(this.baseUrl)}/service-provider-with-user`,data)
//   }

//    signIn(data:Signin): Observable<SignInResponse> {
//     return this.http.post<SignInResponse>(`${environment.baseUrl}/auth/local`, data);
//   }
// }
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Signin, SignInResponse } from '../interfaces/signin.interface';
import { jwtDecode, JwtPayload } from 'jwt-decode';
import { environment } from '../../../environments/environment';
import { tap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private baseUrl = environment.baseUrl;
  private tokenKey = 'AuthorizationKey';  // same as before
  private userKey = 'UserDetails';

  constructor(private http: HttpClient) { }

  // ----------- TOKEN ----------
  setToken(token: string): void {
    localStorage.setItem(this.tokenKey, token);
  }
  
  getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }
  
  setUser(user: any): void {
    localStorage.setItem(this.userKey, JSON.stringify(user));
  }
  
  getUser(): any {
    const user = localStorage.getItem(this.userKey);
    return user ? JSON.parse(user) : null;
  }

  removeToken(): void {
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem(this.userKey);
  }

  logout(): void {
    this.removeToken();
  }
 

  // ----------- AUTH CHECK ----------
  isAuthenticated(): boolean {
    const token = this.getToken();
    if (!token) return false;
  
    try {
      const decoded: any = jwtDecode(token);
      if (!decoded.exp) {
        return true;
      }
  
      const now = Math.floor(Date.now() / 1000);
      return decoded.exp > now;
    } catch (err) {
      console.error('JWT decode failed:', err);
      return false;
    }
  }
  
  // ----------- API CALLS ----------
  nriSignUp(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/auth/local/register`, data);
  }

  serviceProviderSignUp(data: any) {
    return this.http.post(`${this.baseUrl}/service-provider-with-user`, data);
  }

  signIn(data: Signin): Observable<SignInResponse> {
    return this.http.post<SignInResponse>(`${this.baseUrl}/auth/local`, data).pipe(
      tap({
        next: (response) => {
          if (response?.jwt) {
            this.setToken(response.jwt);
            if (response.user) {
              this.setUser(response.user);
            }
          }
        },
        error: (error) => {
          console.error('AuthService - Login error:', error);
        }
      })
    );
  }

  forgotPassword(email: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/forgot-password`, { email });
  }

  resetPassword(code: string, password: string, passwordConfirmation: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/auth/reset-password`, {
        code,
        password,
        passwordConfirmation
    });
  }
}
